import trTR from "antd/lib/locale/tr_TR";
import { ConfigProvider } from "antd";
import React from "react";
import { RouteList } from "routes/RouteList";
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/thumbs";



const App: React.FC = () => (
  <>
    <ConfigProvider theme={{}} locale={trTR}>
      <RouteList />
    </ConfigProvider>
  </>
);

export default App;
